module.exports = __webpack_public_path__ + "static/img/Coen-Hess.62ee0e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Coen-Hess.jpg
// module id = WNax
// module chunks = 0